import Card from "./Card";
import { servicesContent } from "../content/content";

function Services() {
  return (
    <div className="container services">
      <h2 className="main-title text-center">NASZE USŁUGI</h2>
      <div className="card-cover">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-4 mb-2">
              <Card title="Usługi budowlane" img="excavator.png" text={servicesContent.card1} />
            </div>
            <div className="col-md-4 mb-2">
              <Card title="Usługi transportowe" img="truck.png" text={servicesContent.card2} />
            </div>
            <div className="col-md-4 mb-2">
              <Card title="Roboty ziemne" img="road.png" text={servicesContent.card3} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Services;
